import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postControl } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.POST,
  api: postControl,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/controls/PostAction.js